export default __webpack_public_path__ + "static/media/made-case-study.b3ac3be2.png";